module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "pa5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#npa5"
    }
  }, [_c('span', {
    staticClass: "section_number"
  }, [_vm._v("PART 1")]), _c('br'), _c('span', {
    staticClass: "title"
  }, [_vm._v("THE ROACH BOY OF MOUND CAJORIA, A HUMAN-INHABITED ANT COLONY OF THE GREAT AND HOLY SLOPE ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86eff2c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part_1.vue
// module id = 81
// module chunks = 0